import React from 'react';

const LOGO_URL = `${process.env.PUBLIC_URL}/images/logo-sem-fundo.png`;

const HeroBanner = () => {
  return (
    <section className="relative h-auto min-h-[340px] md:min-h-[430px] md:h-[430px] bg-[#5e151c]" data-testid="hero-banner">
      
      {/* Content - responsive flex layout (column on mobile, row on desktop) */}
      <div className="relative z-10 h-full max-w-7xl mx-auto flex max-[1199px]:flex-col min-[1200px]:flex-row items-center justify-center max-[1199px]:gap-1 min-[1200px]:justify-between px-4 md:px-12 py-4 md:py-6 min-[1200px]:py-0">
        
        {/* Left Logo (Top Logo on Mobile) */}
        <img 
          src={LOGO_URL} 
          alt="Logo Café Colonial" 
          className="h-44 sm:h-48 md:h-52 lg:h-60 max-[1200px]:h-40 mb-0 md:mb-0"
        />

        <div className="text-center px-2 md:px-4 flex-1 max-w-full">
          <h1 className="text-lg md:text-4xl font-bold text-white mb-1 max-[1200px]:mb-0" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            <span className="text-[#DAA520]">SEJA BEM VINDO AO</span>
          </h1>
          <h2 className="text-[7vw] sm:text-4xl md:text-5xl font-bold text-white whitespace-normal max-[1199px]:leading-tight min-[1200px]:whitespace-nowrap" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            CAFÉ COLONIAL CESTAS
          </h2>
          <p className="text-white/90 mt-2 text-lg italic" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            "A Favorita da Cidade"
          </p>
          <p className="text-[#DAA520] mt-1 text-sm">
            Desde 05/1992 • Belo Horizonte - MG
          </p>
        </div>

        {/* Right Logo */}
        <img 
          src={LOGO_URL} 
          alt="Logo Café Colonial" 
          className="hidden min-[1200px]:block h-40 sm:h-48 md:h-52 lg:h-60"
        />

      </div>
    </section>
  );
};

export default HeroBanner;
